import React from 'react'
import Editor from 'react-simple-code-editor'
import { Box, type SxProps, type Theme } from '@mui/material'
import hljs from 'highlight.js/lib/core'
import json from 'highlight.js/lib/languages/json'
import xml from 'highlight.js/lib/languages/xml'
import 'highlight.js/styles/vs2015.css'

hljs.registerLanguage('json', json)
hljs.registerLanguage('xml', xml)

type Language = 'xml' | 'json'

interface CodeEditorProps {
  value: string
  onChange: (value: string) => void
  language: Language
  placeholder?: string
  minHeight?: string | number
  sx?: SxProps<Theme>
}

const CodeEditor: React.FC<CodeEditorProps> = ({
  value,
  onChange,
  language,
  placeholder,
  minHeight = '300px',
  sx,
}) => {
  const highlight = (code: string): string => {
    return hljs.highlight(code, { language }).value
  }

  return (
    <Box
      sx={{
        backgroundColor: 'background.secondary',
        borderRadius: '4px',
        overflow: 'auto',
        minHeight,
        '& .code-editor': {
          fontFamily: 'monospace !important',
          fontSize: '12px !important',
          lineHeight: '1.5 !important',
          minHeight: 'inherit',
        },
        '& textarea': {
          outline: 'none !important',
        },
        '& pre': {
          margin: '0 !important',
        },
        '& textarea::placeholder': {
          whiteSpace: 'pre !important',
          overflow: 'visible !important',
        },
        ...sx,
      }}
    >
      <Editor
        value={value}
        onValueChange={onChange}
        highlight={highlight}
        placeholder={placeholder}
        padding={10}
        className='code-editor'
        style={{
          minHeight: typeof minHeight === 'number' ? minHeight : undefined,
        }}
      />
    </Box>
  )
}

export default CodeEditor
